// reducers.js

const initialState = {
    tipDetails: null,
    allTips:null,  // Add this line to your initial state
};

export const Tips = (state = initialState, action) => {
  switch (action.type) {

    case "SET_SELECTED_ROW": {  // Add this case to handle the new action
      return {
        ...state,
        tipDetails: action.payload,
      };
    }
     case "RETRIEVE_ALL_TIPS": {  // Add this case to handle the new action
      return {
        ...state,
        allTips: action.payload,
      };
    }
    default:
      return state;
  }
};
export default Tips;